import { FC, ReactNode, useCallback } from "react";
import {
  Box,
  Grid,
  DialogContent,
  DialogTitle,
  Paper,
  Divider,
} from "@mui/material";

import "./style.css";
import defaultListStore from "src/framework/store/DefaultListStore";
import { Alert } from '@mui/material';
import { resolveProtocolUrl, resolveUploadUrl } from "src/store/global.store";

export interface ConteudoModalInstalacaoMobileProps {
    modulosInversoresState: any[];
    componentesState: any[];
    alerta?: ReactNode;
}

const ConteudoModalInstalacaoMobile: FC<ConteudoModalInstalacaoMobileProps> = ({ componentesState, modulosInversoresState, alerta }) => {
    const stringDinamicas = (numero: number, componente_id: number, moduloInversorState: any) => {
        if (moduloInversorState.length > 0) {
            const modulo_inversor = moduloInversorState?.filter((a: any) => a?.inversor_id === componente_id)
            const strings = modulo_inversor?.filter((a: any) => a?.numero_mppt === numero)
            var stringOrder = strings?.sort((a: { numero_string: number; }, b: { numero_string: number; }) => (a.numero_string > b.numero_string) ? 1 : -1)
            return stringOrder?.map((item: any, index:number) => {
                return (
                    <Grid size={12}>
                        <Box component="h4" className={`string${!index ? ' string-first' : ''}`}>String {item?.numero_string}</Box>
                        <Box component="h2" className="labels-mppt">{item?.quantidade} módulos</Box>
                        <Box component="p" className="modulos-mppt">N.º máx. de módulos: {item?.quantidade_calculada}</Box>
                    </Grid>
                )
            })
        }
    }

    const mpptsDinamicas = (mppts: any, componente_id: number, moduloInversorState: any) => {
        var mpptOrder = mppts?.sort((a: { numero: number; }, b: { numero: number; }) => (a.numero > b.numero) ? 1 : -1)
        return mpptOrder?.map(function(item: any){
            return (
                <Paper style={{ padding: "20px 15px", marginBottom: 25 }}>
                    <Box component="h2" className="titulo-mppt">MPPT {item?.numero} </Box>
                    <Grid size={12}>
                        {stringDinamicas(item?.numero, componente_id, moduloInversorState)}
                    </Grid>
                </Paper>
            )
        })
    }

    const componentesDinamicos = useCallback(() => {
        defaultListStore.getUpload();
        return componentesState && componentesState.length && modulosInversoresState && modulosInversoresState.length > 0 ? modulosInversoresState.map((moduloInversorState: any) => {
            const itemModuloInversor = moduloInversorState[0];
            const item = componentesState.find((c:any) => c.id === itemModuloInversor?.inversor_id);
            const upload = item?.uploads?.find((u: any) => u?.tipo === 'image');
            const uploadUrl = defaultListStore?.uploadUrl || resolveUploadUrl(upload);
            return item ? (
                <Grid container size={12}>
                    <Grid size={{ xs: 12, md: 2 }} style={{ textAlign: "center", marginTop: 15 }}>
                        {upload && <img style={{ width: "180px" }} alt='Componente' src={resolveProtocolUrl(`//${uploadUrl}${upload.url}`)} />}
                    </Grid>
                    <Grid size={{ xs: 12, md: 10 }}>
                        <Grid size={12} style={{ textAlign: "center", marginBottom: 30 }}>
                            <Box component="h3" style={{ marginBottom: "0px" }}>{item?.nome}</Box>
                            <Box component="p" style={{ marginTop: "0px" }}>{item?.descricao}</Box>
                        </Grid>
                        <Grid size={12}>
                            {mpptsDinamicas(item.mppt, item.id, moduloInversorState)}
                        </Grid>
                    </Grid>
                </Grid>
            ) : '';
        
        }) : ''
    },[modulosInversoresState, componentesState]);

    return (
        <>
            <DialogTitle id="alert-dialog-title" >
                Sugestão de instalação
            </DialogTitle>
            
            <Divider />

            <DialogContent className="content-modal">
                <Grid container>
                    {
                        alerta ? (
                            <Alert severity="warning" style={{ marginBottom: 25 }}>
                                {alerta}
                            </Alert>
                        ) : (
                            <Grid size={12} className="content-modal-info">
                                <Grid size={12}>
                                    <Box component="h4"><Box component="span" style={{ color: "red" }} >*</Box> Informações importantes!</Box>
                                    <Box component="p">A disposição de módulos é apenas uma sugestão calculada com base nas premissas abaixo: </Box>
                                    <Box component="ul">
                                        <Box component="li">Valores de HSP (Horas de Sol Pico) com base no banco de dados do INPE (2006);</Box>
                                        <Box component="li">O dimensionamento do sistema considera que os módulos estarão com inclinação ideal e voltados para a direção norte, sem sombreamento;</Box>
                                        <Box component="li">Geração mensal = HSP Médio x Potência do Gerador x 30 x Fator de Perdas:</Box>
                                        <Box component="p" style={{ marginBottom: 0, marginTop: 5 }}>30 - padrão de dias de um mês;</Box>
                                        <Box component="p" style={{ marginBottom: 0, marginTop: 3 }}>Fator de perdas - 12%;</Box>
                                        <Box component="p" style={{ marginTop: 3 }}>Correção de temperatura (disponível na tela de componentes);</Box>
                                    </Box>
                                    <Box component="p">Isso poderá variar de acordo com o projeto, desde que sejam respeitadas as características técnicas dos produtos e atendendo
                                        aos requisitos exigidos pelas normas vigentes, concessionária ou cooperativa local. Além disso, strings que pertencem ao
                                        mesmo MPPT devem ter a mesma quantidade de módulos fotovoltaicos conectados em série.</Box>
                                </Grid>
                            </Grid>
                        )
                    }

                    {
                        componentesDinamicos()
                    }
                </Grid>
            </DialogContent>
        </>
    );
};

export { ConteudoModalInstalacaoMobile };
